var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _g3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _g5, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 424,
    viewBox: "0 0 480 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.107 97.3441L142.689 114.306L73.2529 74.022L103.731 57.0605L172.107 97.3441Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.107 186.923L142.689 203.885L73.2529 163.601L103.731 146.64L172.107 186.923Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M171.939 186.923L142.521 203.885L73.085 163.601L103.563 146.64L171.939 186.923Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 114.307V203.884",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.995 57.0605V146.638L73.2822 163.57V73.9926",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.106 97.0508V186.629",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.545 130.444L84.1275 147.405L14.6914 107.122L45.1691 90.1602L113.545 130.444Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.545 220.022L84.1275 236.983L14.6914 196.7L45.1691 179.738L113.545 220.022Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.378 220.022L83.9605 236.983L14.5244 196.7L45.0021 179.738L113.378 220.022Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1289 147.405V236.983",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4349 90.1602V179.738L14.7217 196.67V107.092",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.545 130.149V219.727",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M359.67 142.134L330.252 159.096L260.816 118.812L291.294 101.851L359.67 142.134Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M359.67 231.712L330.252 248.674L260.816 208.39L291.294 191.429L359.67 231.712Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.503 231.712L330.086 248.674L260.649 208.39L291.127 191.429L359.503 231.712Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M330.252 159.095V248.673",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M291.558 101.851V191.428L260.845 208.36V118.783",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M359.671 141.84V231.418",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.826 192.674L421.409 209.636L351.973 169.352L382.45 152.391L450.826 192.674Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.826 282.252L421.409 299.214L351.973 258.93L382.45 241.969L450.826 282.252Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.659 282.252L421.242 299.214L351.806 258.93L382.283 241.969L450.659 282.252Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.409 209.636V299.214",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.716 152.391V241.968L352.003 258.901V169.323",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.826 192.38V281.958",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.024 81.5501L225.442 98.5116L294.878 58.2281L264.4 41.2666L196.024 81.5501Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.024 171.128L225.442 188.09L294.878 147.806L264.4 130.845L196.024 171.128Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.192 171.128L225.61 188.09L295.046 147.806L264.568 130.845L196.192 171.128Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.442 98.5117V188.09",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M264.136 41.2666V130.844L294.849 147.776V58.1986",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M196.024 81.2568V170.835",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.284 41.1898L160.702 58.1512L230.138 17.8677L199.66 0.90625L131.284 41.1898Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.284 130.768L160.702 147.729L230.138 107.446L199.66 90.4844L131.284 130.768Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.451 130.768L160.869 147.729L230.305 107.446L199.827 90.4844L131.451 130.768Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.702 58.1514V147.729",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.396 0.90625V90.4841L230.109 107.416V17.8383",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.284 40.8955V130.473",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.445 316.333L229.863 333.295L299.299 293.011L268.821 276.05L200.445 316.333Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.445 405.911L229.863 422.873L299.299 382.589L268.821 365.628L200.445 405.911Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.612 405.911L230.03 422.873L299.466 382.589L268.988 365.628L200.612 405.911Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.863 333.295V422.873",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.557 276.05V365.628L299.27 382.56V292.982",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.445 316.039V405.617",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 276.16L172.106 293.121L241.542 252.837L211.064 235.876L142.688 276.16Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 365.737L172.106 382.698L241.542 342.415L211.064 325.453L142.688 365.737Z",
    stroke: "#231F20",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M142.856 365.737L172.274 382.698L241.71 342.415L211.232 325.453L142.856 365.737Z",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.106 293.12V382.698",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.799 235.876V325.454L241.512 342.386V252.808",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M142.688 275.864V365.442",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5029 93.5068L468.018 345.899",
    stroke: "white",
    strokeWidth: 11.0548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.839 316.111L317.35 370.015L96.6816 241.994L193.54 188.09L410.839 316.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 296.433L103.858 242.529",
    stroke: "white",
    strokeWidth: 11.0548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4598 275.563L7 295.75L27.8329 302.695",
    stroke: "white",
    strokeWidth: 11.0548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.882 352.969L472.401 347.66L467.158 326.336",
    stroke: "white",
    strokeWidth: 11.0548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.385 83.0771L34.0547 91.7708L42.82 111.905",
    stroke: "white",
    strokeWidth: 11.0548,
    strokeMiterlimit: 10
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M358.57 262.757L232.258 336.991",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10,
    strokeDasharray: "3.81 3.81"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M276.203 217.211L236.493 240.549",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10,
    strokeDasharray: "3.81 3.81"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M317.015 285.941L155.974 195.893",
    stroke: "white",
    strokeWidth: 1.38185,
    strokeMiterlimit: 10,
    strokeDasharray: "3.81 3.81"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSm);
export default __webpack_public_path__ + "static/media/desktop-sm.7b8fcb3ff9f98453751d7b66f22168b6.svg";
export { ForwardRef as ReactComponent };